export default __webpack_public_path__ + "static/media/golang-webapp-scr1.607c5fa6.png";